import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import { IdeasState } from "src/pods/ideas";

type DisplayState = IdeasState["display"];

export const SEND_IDEAS = createAction("SEND_IDEAS");
export const RECEIVE_IDEAS = createAction("RECEIVE_IDEAS");

export const sendHideVideo = createActionCreator(SEND_IDEAS, () => ({
  isPlaying: false,
  watch: null,
}));

export const sendVideoPlaybackState = createActionCreator(SEND_IDEAS, (isPlaying: DisplayState["isPlaying"]) => ({
  isPlaying,
}));

export const sendVideoIsFullscreen = createActionCreator(SEND_IDEAS, (isFullscreen: DisplayState["isFullscreen"]) => ({
  isFullscreen,
}));

export const sendSeekOffset = createActionCreator(SEND_IDEAS, (seekOffset: DisplayState["seekOffset"]) => ({
  seekOffset,
}));
